export default __webpack_public_path__ + "static/media/recreational_fishing_icon.06b7ae77.svg";